import InputText from '@libs/useful/InputText'
import { __ } from '@libs/utilities'
import { useEffect, useState } from 'react'
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar' 
import { Button, Intent } from '@blueprintjs/core' 
import { showToast } from '@libs/useful'

export const URL_SEPARATOR = "$@$@$@$@$@$@$@"
 
export const getURL = (url: string) => {
    return url?.split(URL_SEPARATOR) || ["", ""]
}

const URL = (props: IScalarForm) : JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<URLEnabled {...props} />}
        desabledForm={<URLDisabled {...props} />}
    />
} 
export default URL 

let _title: string 
let _link :string
const URLEnabled = ( props: IScalarForm ): JSX.Element => { 
    const LINK_MUST_BE_URL =  __("Error: link must be url")
    const [title, setTitle] = useState<string>("")
    const [link, setLink] = useState<string>("") 
    const [descr, setDescr] = useState<string>("") 
    const [tick, setTick] = useState<boolean>(false) 
    const [isLabel, setIsLabel] = useState<boolean>(false) 
    useEffect(() => {
        const val: string[] = props.value?.split(URL_SEPARATOR) || ["", ""]
        setTitle( val[1] || "" )
        setLink(  val[0] || "" )
    }, [])
    const getURL = () => { 
        return !!(_link || _title) ? [ _link, _title ].join(URL_SEPARATOR) : ""
    }
    const onChangeURL = (evt: any) => { 
        const value:string = evt.currentTarget.value
        const check = value.indexOf( "http" )
        if(check !== 0) {
            setDescr(LINK_MUST_BE_URL)  
        }
        setDescr("")
        setLink(value) 
        _link = value
        onChange()   
    }
    const onChangeTitle = (evt: any) => { 
        const value = evt.currentTarget.value
        setTitle( value )  
        _title = value
        onChange()   
        if(link.indexOf("http") !== 0){
            setDescr(LINK_MUST_BE_URL)
        }
    }
    const onCBURL = async ( data: string | null ) => {
        if(!data) return
        const check = data.indexOf( "http" )
        if(check !== 0) {
            showToast({
                message: "string must be http link",
                intent: Intent.DANGER
            })
            return 
        }
        setLink( data ) 
        _link = data
        onChange()
    }
    const onCBTitle = ( data: string | null ) => { 
        if(!data?.trim()) return
        setTitle( data.trim() )
        _title = data.trim()
        setTick(!tick)
        onChange()
        if(link.indexOf("http") !== 0){
            setDescr(LINK_MUST_BE_URL)
        }
    }
    const onChange = () => {
        if( props.onChange )
        { 
            const oCh = props.onChange 
            const url = getURL() 
            const field = props.field 
            setTimeout(() => {
                // console.log( url )
                oCh( url, field, "" )
            }, 1300)
        }
    }
    const onLabel = () => {
        setIsLabel(true)
    }
    
    return <div className='w-100'> 
        <div className=" d-flex justify-content-center flex-column my-2 p-0 w-100">
            <div className="w-100 d-flex align-items-center">
                <i className="fas fa-desktop" />
                <InputText 
                    className="form-control input dark"
                    value={ link || "" }
                    placeholder={__("write link")}
                    onChange={ onChangeURL }
                    onPaste={onCBURL}
                />
            </div>
            {
                isLabel 
                    ?
                    <div className="w-100 d-flex align-items-center">
                        <i className="fas fa-pen-nib" />
                        <InputText
                            className="form-control input dark"
                            value={ title || ""}
                            placeholder={ __( "write label" ) }
                            onChange={ onChangeTitle }
                            onPaste={ onCBTitle }
                        />
                    </div>
                    :
                    <Button variant="minimal" size="small" alignText='left' onClick={onLabel}>
                        <div className="smaller letter-spacing-1 opacity_5">
                            { __( "Add link label" ) }
                        </div>
                    </Button>
            }
            
            <div className='text-danger descr'>
                { descr }
            </div>
        </div>
    
    </div>
} 
 
const URLDisabled = ( props: IScalarForm ): JSX.Element | false => {
    const [title, setTitle] = useState<string>("")
    const [link, setLink] = useState<string>("")
    useEffect(() => { 
        const val: string[] = props.value?.split(URL_SEPARATOR) || ["", ""]
        setTitle(val[1])
        setLink( val[0]) 
    }, []) 

    const onClick = (evt: any) => {
        evt.stopPropagation()
        evt.preventDefault() 
        window.open(link,'_blank')
    }
    return !!link && <div className='d-flex align-items-center w-100'>
        <div className='lead opacity_75'> 
            <i className="fas fa-link mr-2"></i>
		</div>
        <a 
            href={link} 
            target="_blank" 
            rel="noreferrer" 
            className="text-overflow bp3-text-overflow-ellipsis"
            onClick={onClick}
        >            
            {`${ title?.trim() || "link"} `}
        </a>

        
    </div> 
} 


export function checkURL(string: string) : boolean {
    const [link, title] = string.split( URL_SEPARATOR )
    return link.indexOf("http") === 0
}